import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { isIdAzureIntroContactAndStudioFormValid } from "../../helpers/formValidation";
import { compareIdAzureApplicationStepStatus } from "../../helpers/idAzureStatusHelpers";
import { IdAzureIntroContactDataType } from "../../models/forms";
import { IdAzureApplicationStep } from "../../models/status";
import {
  IdAzureIntroFormId,
  IdAzureIntroSubFormsId,
} from "../../pages/IdAzureIntroPage/IdAzureIntroPageConstants";
import { OnboardingRootState } from "../../redux/reducers/rootReducer";
import { getIdAzureApplicationStep, getSubFormData } from "../../redux/selectors";

const stepPercentageValue = 50;
const increasePercentageIfValid = (isFormValid: boolean, currentPercentage: number): number =>
  isFormValid ? currentPercentage + stepPercentageValue : currentPercentage;

export const useIdAzurePercentage = () => {
  const [percentage, setPercentage] = useState(0);
  const currentStep = useSelector(getIdAzureApplicationStep) ?? IdAzureApplicationStep.Unset;

  // ID@Azure Introduction sub form data
  const idAzureIntroContactSubFormData = useSelector((state: OnboardingRootState) =>
    getSubFormData(state, IdAzureIntroFormId, IdAzureIntroSubFormsId.ContactAndStudio)
  ) as IdAzureIntroContactDataType;

  useEffect(() => {
    const calculatePercentage = async () => {
      if (currentStep === IdAzureApplicationStep.Unset) {
        setPercentage(0);
      }

      let tempPercentage = 0;

      const isIdAzureContactFormValid =
        (await isIdAzureIntroContactAndStudioFormValid(idAzureIntroContactSubFormData)) &&
        idAzureIntroContactSubFormData.isStarted;

      tempPercentage = increasePercentageIfValid(isIdAzureContactFormValid, tempPercentage);
      const isApplicationComplete =
        compareIdAzureApplicationStepStatus(
          currentStep,
          IdAzureApplicationStep.ApplicationComplete
        ) >= 0;

      if (!isApplicationComplete) {
        setPercentage(tempPercentage);
        return;
      }

      tempPercentage = increasePercentageIfValid(isApplicationComplete, tempPercentage);

      setPercentage(tempPercentage);
    };

    calculatePercentage();
  }, [currentStep, idAzureIntroContactSubFormData]);

  return percentage;
};
